import React , {Component} from 'react';

import {Link} from "react-router-dom";
import backIcon from './../assets/images/icons/back-2.svg';
import arrowLeftIcon from './../assets/images/icons/arrow-left.svg';
import * as axios from "axios/index";
import * as vars from './Vars';
import NumberFormat from 'react-number-format';
import Loader from './loader/OrdersLoader';

class Orders extends Component{

    constructor(props){

        super(props)
        this.state = {
            page : 1 ,
            orders : [] ,
            requestLoading : true ,
            hasMore : true ,
        }
    }

    componentDidMount(){
        let data = new FormData()
        data.append('api_token' , localStorage.getItem("api_token") )
        data.append('page' , this.state.page )
        axios.post(vars.Url +'api/v1/order' , data , {
            params : {
            }

        } )
        .then(response => {
            let data = response.data.data
            this.setState({
                requestLoading : false ,
                orders : data.orders ,
                hasMore : data.hasMore  ,
                page : this.state.page + 1
            })
        })
        .catch(error => {
            // console.log(error)
        })


        document.addEventListener('scroll', this.trackScrolling)
    }


    isBottom(el) {
        return el.getBoundingClientRect().bottom <= window.innerHeight + 100;
    }

    trackScrolling = () => {
        const wrappedElement = document.getElementById('body');
        if (this.isBottom(wrappedElement)) {

            if (this.state.hasMore === true && this.state.requestLoading === false)
            {
                this.setState({
                    requestLoading :true ,
                })
                let data = new FormData()
                data.append('api_token' , localStorage.getItem("api_token") )
                data.append('page' , this.state.page )
                axios.post(vars.Url +'api/v1/order' , data , {
                    params : {
                    }

                } )
                .then(response => {
                    let data = response.data.data
                    this.setState({
                        requestLoading : false ,
                        orders : [...this.state.orders , ...data.orders] ,
                        hasMore : data.hasMore ,
                        page : this.state.page + 1
                    })
                })
                .catch(error => {
                    // console.log(error)
                })
            }

        }
    }

    componentWillUnmount(){
        document.removeEventListener('scroll', this.trackScrolling)
    }

    render(){
        return(

            <div id="main-custom-1" className="text-decoration-none">
                 <header id="header-3">
                    <div className="container p-0">
                        <div className="row no-gutters justify-content-center">
                            <div className="col-lg-6">
                                <div className="items-container">
                                    <div className="row justify-content-between">
                                        <div className="col-auto">
                                            <Link to="/profile">
                                                <span>
                                                    <img src={backIcon} alt="back" className="item-icon" />
                                                </span>
                                            </Link>
                                            <span className="title">
                                                خریدهای من
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </header>


                <div className="container p-0 mt-5">
                    <div className="row no-gutters justify-content-center">
                        <div className="col-lg-6">
                            <div className="items-container items-container-custom-1">

                                {
                                    this.state.orders.map((order , index) =>
                                        <Link to={"/order/" + (order.orderNumber)} className="card-custom-15" key={index}>
                                            <div className="row no-gutters justify-content-between align-items-center">
                                                <div className="col-auto">
                                                    <div className="title">
                                                        {order.deliveryDate}
                                                    </div>
                                                </div>
                                                <div className="col-auto">
                                                    <div className={"status " +
                                                            (order.status === "USER-CANCELED" || order.status === "ADMIN-CANCELED" || order.status === "PAY-CANCELED"  ? "status-danger" : "")
                                                            +
                                                            (order.status === "BEFORE-PAY" || order.status === "IN-PROCESS" || order.status === "CONFIRMED" || order.status === "SENT"  ? "status-success" : "")
                                                            +
                                                            (order.status === "DELIVERED" ? "status-info" : "")
                                                    }>
                                                        {order.trackingTitle}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row no-gutters mt-4">
                                                <div className="col">
                                                    <div className="products">
                                                        { order.products }
                                                    </div>
                                                </div>
                                            </div>


                                            <div className="row no-gutters justify-content-between align-items-center mt-2">
                                                <div className="col-auto">

                                                    <div className="price">
                                                        مبلغ نهایی:
                                                        <NumberFormat value={ order.price } displayType={'text'} thousandSeparator={true} className="pl-1 pr-1" />
                                                        تومان
                                                    </div>
                                                </div>
                                                <div className="col-auto">
                                                    <img src={arrowLeftIcon} alt="arrow left"/>
                                                </div>
                                            </div>

                                        </Link>
                                    )
                                }

                                {
                                    this.state.requestLoading === true ? (<Loader />) : (``)
                                }

                            </div>
                        </div>
                    </div>
                </div>

            </div>
        )
    }
}

export default Orders;